<ng-container *ngIf="groupedCartItems.length > 0; else emptyCart">
  <div *ngIf="unavailableItemCount > 0" class="alert alert-warning">
    <nz-tag nzColor="orange">Notice</nz-tag> {{ unavailableItemCount }} items were not included in
    the checkout due to not being available for sale.
  </div>
  <div
    *ngIf="!selectedNetwork"
    class="alert alert-warning border-2 rounded-xl border-alerts-error p-3"
  >
    <nz-tag nzColor="orange" class="font-bold">Select Network Purchase</nz-tag> Bulk purchase of
    NFTs are only allowed on one network per transaction. Please select the network group of NFTs
    you'd like to purchase below. You can click on the network to toggle visibility of the NFTs to
    purchase for that network. After making your selection you can confirm and lock the group of
    NFTs to generate the purchase transaction.
  </div>
  <nz-divider></nz-divider>

  <div class="checkout-cart-items" *ngFor="let group of groupedCartItems">
    <div
      *ngIf="group.tokenSymbol === selectedNetwork || currentStep === stepType.CONFIRM"
      class="radio-option rounded-xl"
      [ngClass]="{ selected: selectedNetwork === group.tokenSymbol }"
      (click)="setNetworkSelection(group.tokenSymbol)"
    >
      <div nz-row nzJustify="space-between" nzAlign="middle" class="group-header">
        <div nz-col nzSpan="20">
          <h3 nz-typography nzTitle level="4" class="mb-2">
            Network: <span class="uppercase">{{ group.tokenSymbol }}</span> -
            <span class="font-bold">{{ group.totalQuantity }}</span> NFTs in network group with
            total Price of
            {{ group.totalPrice | formatToken : group.network : true : true | async }} ({{
              unitsService.getUsd(
                cartService.valueDivideExponent({
                  value: group.totalPrice || 0,
                  exponents: cartService.getDefaultNetworkDecimals()
                }),
                group.network
              )
                | async
                | currency : 'USD'
                | UsdBelowTwoDecimals
            }}
            USD)
          </h3>
        </div>
        <div nz-col nzSpan="4" *ngIf="currentStep !== stepType.CONFIRM">
          <button (click)="toggleGroup($event, group.tokenSymbol)">
            {{ isGroupExpanded(group.tokenSymbol) ? 'Hide' : 'Show' }}
            <span class="uppercase">{{ group.tokenSymbol }}</span> Items
          </button>
        </div>
      </div>

      <label>
        <input
          type="radio"
          name="selectedNetwork"
          [(ngModel)]="selectedNetwork"
          [value]="group.tokenSymbol"
          (change)="setNetworkSelection(group.tokenSymbol)"
        />
        Select this network/group of NFTs for payment
      </label>

      <div *ngIf="isGroupExpanded(group.tokenSymbol)">
        <ng-container *ngIf="deviceService.isMobile$ | async; else isDesktop">
          <nz-table
            [nzData]="group.items"
            [nzShowPagination]="false"
            [nzFrontPagination]="false"
            nzSize="small"
            [ngClass]="{
              'table-dark': (themeService.theme$ | async) === themes.Dark,
              'table-light': (themeService.theme$ | async) === themes.Light
            }"
          >
            <thead>
              <tr>
                <th nzWidth="60%">NFT Info</th>
                <th nzWidth="20%">Qty</th>
                <th nzWidth="20%">Price</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of group.items; let i = index">
                <tr>
                  <td>
                    <!-- NFT -->
                    <div>
                      <span class="underline font-bold"> NFT: </span>
                      <span
                        class="text-blue-500 hover:text-blue-600 cursor-pointer"
                        (click)="goToNft(item.nft.uid)"
                      >
                        {{ item.nft.name }}
                      </span>
                    </div>

                    <!-- Collection -->
                    <div>
                      <span class="underline font-bold"> COL: </span>
                      <span
                        class="text-blue-500 hover:text-blue-600 cursor-pointer"
                        (click)="goToCollection(item.collection.uid)"
                      >
                        {{ item.collection.name }}
                      </span>
                    </div>

                    <!-- Royalties -->
                    <div>
                      <span class="underline font-bold"> Royalties: </span>
                      <span> {{ (item.collection.royaltiesFee || 0) * 100 }}% </span>
                    </div>
                  </td>

                  <td>{{ item.quantity }}</td>
                  <td>
                    {{
                      item.salePrice
                        | formatToken
                          : (item.nft.placeholderNft
                              ? item.collection.mintingData?.network
                              : item.nft.mintingData?.network)
                          : true
                          : true
                        | async
                    }}
                    <br />
                    ({{
                      unitsService.getUsd(
                        cartService.valueDivideExponent({
                          value: item.salePrice || 0,
                          exponents: cartService.getDefaultNetworkDecimals()
                        }),
                        group.network
                      )
                        | async
                        | currency : 'USD'
                        | UsdBelowTwoDecimals
                    }}
                    USD)
                  </td>
                </tr>
              </ng-container>
              <tr>
                <td>
                  <strong> Total </strong>
                </td>
                <td>
                  <strong>
                    {{ group.totalQuantity }}
                  </strong>
                </td>
                <td>
                  <strong>
                    {{ group.totalPrice | formatToken : group.network : true : true | async }}
                    <br />
                    ({{
                      unitsService.getUsd(
                        cartService.valueDivideExponent({
                          value: group.totalPrice || 0,
                          exponents: cartService.getDefaultNetworkDecimals()
                        }),
                        group.network
                      )
                        | async
                        | currency : 'USD'
                        | UsdBelowTwoDecimals
                    }}
                    USD)
                  </strong>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </ng-container>

        <ng-template #isDesktop>
          <nz-table
            [nzData]="group.items"
            [nzShowPagination]="false"
            [nzFrontPagination]="false"
            nzSize="small"
            [ngClass]="{
              'table-dark': (themeService.theme$ | async) === themes.Dark,
              'table-light': (themeService.theme$ | async) === themes.Light
            }"
          >
            <thead>
              <tr>
                <th nzWidth="16%">NFT Name</th>
                <th nzWidth="16%">Collection Name</th>
                <th nzWidth="16%">Royalties Fee</th>
                <th nzWidth="16%">Quantity Added</th>
                <th nzWidth="16%">
                  Price (<span class="uppercase">{{ group.tokenSymbol }}</span
                  >) (USD Value)
                </th>
                <th nzWidth="20%">Line Item Total (USD Value)</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of group.items; let i = index">
                <tr>
                  <td>
                    <span
                      class="text-blue-500 hover:text-blue-600 cursor-pointer"
                      (click)="goToNft(item.nft.uid)"
                    >
                      {{ item.nft.name }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="text-blue-500 hover:text-blue-600 cursor-pointer"
                      (click)="goToCollection(item.collection.uid)"
                    >
                      {{ item.collection.name }}
                    </span>
                  </td>
                  <td>{{ (item.collection.royaltiesFee || 0) * 100 }}%</td>
                  <td>{{ item.quantity }}</td>
                  <td>
                    {{
                      item.salePrice
                        | formatToken
                          : (item.nft.placeholderNft
                              ? item.collection.mintingData?.network
                              : item.nft.mintingData?.network)
                          : true
                          : true
                        | async
                    }}
                    &nbsp; ({{
                      unitsService.getUsd(
                        cartService.valueDivideExponent({
                          value: item.salePrice || 0,
                          exponents: cartService.getDefaultNetworkDecimals()
                        }),
                        group.network
                      )
                        | async
                        | currency : 'USD'
                        | UsdBelowTwoDecimals
                    }}
                    USD)
                  </td>
                  <td>
                    {{
                      item.quantity * item.salePrice
                        | formatToken
                          : (item.nft.placeholderNft
                              ? item.collection.mintingData?.network
                              : item.nft.mintingData?.network)
                          : true
                          : true
                        | async
                    }}
                    &nbsp; ({{
                      unitsService.getUsd(
                        cartService.valueDivideExponent({
                          value: item.quantity * item.salePrice || 0,
                          exponents: cartService.getDefaultNetworkDecimals()
                        }),
                        group.network
                      )
                        | async
                        | currency : 'USD'
                        | UsdBelowTwoDecimals
                    }}
                    USD)
                  </td>
                </tr>
              </ng-container>
              <tr>
                <td></td>
                <td></td>
                <td><strong>Total</strong></td>
                <td>
                  <strong>{{ group.totalQuantity }}</strong>
                </td>
                <td></td>
                <td>
                  <strong>
                    {{ group.totalPrice | formatToken : group.network : true : true | async }}
                    &nbsp; ({{
                      unitsService.getUsd(
                        cartService.valueDivideExponent({
                          value: group.totalPrice || 0,
                          exponents: cartService.getDefaultNetworkDecimals()
                        }),
                        group.network
                      )
                        | async
                        | currency : 'USD'
                        | UsdBelowTwoDecimals
                    }}
                    USD)
                  </strong>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </ng-template>
      </div>
    </div>
    <nz-divider></nz-divider>
  </div>

  <nz-divider></nz-divider>

  <div [ngSwitch]="currentStep" class="w-full pb-2">
    <ng-container *ngSwitchCase="stepType.CONFIRM">
      <ng-container *ngTemplateOutlet="confirmTemplate"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="stepType.TRANSACTION">
      <ng-container *ngTemplateOutlet="transactionTemplate"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="stepType.WAIT">
      <ng-container *ngTemplateOutlet="waitTemplate"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="stepType.COMPLETE">
      <ng-container *ngTemplateOutlet="completeTemplate"></ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #emptyCart>
  <nz-empty nzNotFoundContent="No cart items were available for sale."></nz-empty>
  <div class="flex flex-col items-center w-full mt-8 lg:flex-row lg:w-auto">
    <button
      nz-button
      nzType="primary"
      nzSize="large"
      class="w-full lg:mr-2"
      i18n
      (click)="handleClose(false)"
    >
      Close checkout
    </button>
  </div>
</ng-template>

<ng-template #confirmTemplate>
  <div class="wen-transaction-select-container">
    <wen-terms-and-conditions
      class="lg:ml-6"
      [isChecked]="agreeTermsConditions"
      documentLink="https://docs.google.com/document/d/1ng67fXTdINhmgkLpnbS_SkiDlZSsDAqrd13cbwXQCcQ"
      (wenOnCheckChange)="agreeTermsConditions = $event"
    >
    </wen-terms-and-conditions>

    <button
      nz-button
      nzType="primary"
      nzSize="large"
      class="w-full mt-6 lg:w-auto"
      [disabled]="!agreeTermsConditions"
      *ngIf="auth.isLoggedIn$ | async"
      i18n
      (click)="initiateBulkOrder()"
    >
      Confirm and Lock
    </button>

    <wen-connect-wallet
      class="w-full"
      wrapperClass="bg-backgrounds-tertiary dark:bg-backgrounds-tertiary-dark text-foregrounds-primary dark:text-foregrounds-primary-dark"
      *ngIf="(auth.isLoggedIn$ | async) !== true"
    ></wen-connect-wallet>

    <div
      class="mt-4 text-xs font-medium text-foregrounds-secondary dark:text-foregrounds-secondary-dark"
      *ngIf="auth.isLoggedIn$ | async"
    >
      <span i18n>Your NFTs will be locked for purchase for</span> {{ lockTime }}
      <span i18n>minutes</span>.
    </div>
  </div>
</ng-template>

<ng-template #transactionTemplate>
  <div class="wen-transaction-active-container">
    <div class="px-4 py-2.5 rounded-2xl border border-alerts-error flex">
      <wen-icon-stopwatch class="mr-2 lg:mr-3"></wen-icon-stopwatch>
      <div class="text-base font-medium">
        <span *ngIf="!helper.isExpired(transaction$ | async)">{{
          expiryTicker$ | async | countdownTime
        }}</span>
        <span class="text-alerts-error" *ngIf="!helper.isExpired(transaction$ | async)" i18n>
          remaining to make the transfer.</span
        >
        <span class="text-alerts-error" *ngIf="helper.isExpired(transaction$ | async)" i18n
          >Expired</span
        >
      </div>
    </div>

    <nz-alert
      class="mt-2"
      nzType="warning"
      nzShowIcon
      *ngIf="!helper.isExpired(transaction$ | async) && invalidPayment"
      i18n-nzMessage
      nzMessage="We received invalid amount. Try again."
    ></nz-alert>

    <wen-send-funds
      class="block w-full"
      *ngIf="!helper.isExpired(transaction$ | async)"
      [targetAddress]="targetAddress"
      [formattedAmount]="targetAmount | formatToken : getSelectedNetwork() : true | async"
    >
    </wen-send-funds>

    <wen-wallet-deeplink
      *ngIf="!helper.isExpired(transaction$ | async)"
      class="mt-6"
      [targetAddress]="targetAddress"
      [network]="getSelectedNetwork()"
      [targetAmount]="(targetAmount || 0).toString()"
    >
    </wen-wallet-deeplink>
  </div>
</ng-template>

<ng-template #waitTemplate>
  <div class="wen-transaction-wait-container">
    <div class="w-full my-8 border border-inputs-border dark:border-inputs-border-dark rounded-2xl">
      <div class="wen-modal-block-title" i18n>Transaction history</div>

      <div class="wen-modal-history-log">
        <div *ngFor="let t of history; let first = first" class="wen-modal-history-log-item">
          <div class="mr-2 text-sm font-medium text-foregrounds-secondary">{{ t.date | Time }}</div>
          <a
            class="absolute text-sm font-medium underline left-16 wen-btn-link"
            target="_blank"
            *ngIf="t.link"
            [href]="transactionService.getExplorerLink(t.transaction)"
            >{{ t.label }}</a
          >
          <div class="absolute text-sm font-medium left-16" *ngIf="!t.link">{{ t.label }}</div>
        </div>
      </div>
    </div>

    <button
      nz-button
      nzSize="large"
      nzType="default"
      class="flex items-center border-inputs-border dark:border-inputs-border-dark"
    >
      <wen-icon-refresh
        class="mr-3 text-foregrounds-secondary dark:text-foregrounds-secondary-dark animate-spin"
      ></wen-icon-refresh>
      <div class="text-foregrounds-primary dark:text-foregrounds-primary-dark" i18n>
        Validating your transaction...
      </div>
    </button>
  </div>
</ng-template>

<ng-template #completeTemplate>
  <div class="wen-transaction-active-container">
    <div class="w-full my-8 border border-inputs-border dark:border-inputs-border-dark rounded-2xl">
      <div class="wen-modal-block-title" i18n>Transaction history</div>

      <div class="h-auto px-5 pt-4 pb-2">
        <div *ngFor="let t of history; let first = first" class="wen-modal-history-log-item">
          <div class="mr-2 text-sm font-medium text-foregrounds-secondary">{{ t.date | Time }}</div>
          <a
            class="absolute text-sm font-medium underline left-16 wen-btn-link"
            target="_blank"
            *ngIf="t.link"
            [href]="transactionService.getExplorerLink(t.transaction)"
            >{{ t.label }}</a
          >
          <div class="absolute text-sm font-medium left-16" *ngIf="!t.link">{{ t.label }}</div>
        </div>
      </div>
    </div>

    <div class="flex lg:items-center">
      <div
        class="flex items-center justify-center w-10 h-10 rounded-full bg-alerts-success dark:bg-alerts-success-dark"
      >
        <wen-icon-check
          class="text-foregrounds-on-primary dark:text-foregrounds-on-primary-dark"
        ></wen-icon-check>
      </div>
      <div class="ml-3.5 text-lg font-medium" i18n>Transaction complete. Congratulations.</div>
    </div>

    <div class="flex flex-col items-center w-full mt-8 lg:flex-row lg:w-auto">
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        class="w-full lg:mr-2 mb-2"
        i18n
        (click)="handleClose(false)"
      >
        Close checkout
      </button>
    </div>

    <div class="flex flex-col items-center w-full mt-8 lg:flex-row lg:w-auto">
      <button
        nz-button
        nzType="default"
        nzSize="large"
        class="w-full lg:mr-2 mb-2"
        i18n
        (click)="goToMemberNfts()"
      >
        View NFTs
      </button>
    </div>
  </div>
</ng-template>
